import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Choice = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const Hint = styled.p`
    margin: 10px 0 0;
    font-size: 12px;
    line-height: 1.4;
    color: ${colors.textSecondary};
`;
